import { render, staticRenderFns } from "./QuestionSectionPrint.vue?vue&type=template&id=7636f8b2&scoped=true&"
import script from "./QuestionSectionPrint.vue?vue&type=script&lang=js&"
export * from "./QuestionSectionPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7636f8b2",
  null
  
)

export default component.exports